import { Button, InputField, RadioButton, TableWrapper } from 'components/Global';
import { ReactComponent as PeopleIcon } from 'icons/people-filled-icon.svg';
import { ReactComponent as ArrowLeft } from 'icons/arrow-left.svg';

import { useAppContext } from 'components/Context/AppContext';
import { checkEmptyObject, setCurrency } from 'utils/functionality';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import LoadingSpinner from 'components/Global/LoadingSpinner';
import SelectFieldDropdown from 'components/Global/SelectFieldDropdown';
import { getInfluencerById, updateInfluencer } from 'features/influencer/actions';
import { trackEvent } from 'utils/analytics';
import { getAllCategories } from 'features/category/actions';
import { format } from 'date-fns';
import { generateReferralLink } from '.';
import InfluencerMetricsChart from './influencer-metrics-chart';
import ReferralHistory from './referral-history';

const arrayRadionButton = [
  {
    id: 'pr1',
    label: 'Harga Fixed',
    value: 'fixed',
  },
  {
    id: 'pr2',
    label: 'Harga Percentage',
    value: 'percentage',
  },
];

const InfluencerDetailPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { influencerId } = useParams();

  const { showToast, setShowConfirmation } = useAppContext();
  const { byId, referralHistory, isLoading } = useSelector((state) => state.influencer);
  const categories = useSelector((state) => state.category.data);

  const [influencerData, setInfluencerData] = useState({
    name: '',
    referral_link: '',
    value: '',
    value_type: '',
    referral: '',
    services: [],
    categories: [],
    percentage_rule: '',
    total_click: 0,
  });
  const [isActive, setIsActive] = useState(false);
  const [priceType, setPriceType] = useState('');

  useEffect(() => {
    if (!influencerId) return;

    dispatch(getInfluencerById(influencerId));
    dispatch(getAllCategories({ page: 1 }));
  }, [influencerId]);

  const toggleStatus = async () => {
    const newStatus = !isActive;

    const payload = {
      id: byId.id,
      fullname: byId.name,
      referral: byId.referral,
      is_influencer: true,
      value_type: byId.referral_setting.value_type,
      value: byId.referral_setting.value,
      services: byId.referral_setting.services,
      categories: byId.referral_setting.categories,
      min_duration: byId.referral_setting.min_duration,
      ...(byId.referral_setting.percentage_rule !== null && {
        percentage_rule: byId.referral_setting.percentage_rule,
      }),
      is_influencer_active: newStatus,
    };

    setShowConfirmation({
      message: isActive
        ? 'Apakah anda yakin ingin Menonaktifkan Influencer?'
        : 'Apakah anda yakin ingin mengaktifkan Influencer kembali?',
      show: true,
      onClick: async () => {
        // Optimistic update (UI changes immediately)
        setIsActive(newStatus);

        try {
          trackEvent('influencer_status_updated', { influencer_id: influencerId, source: 'influencer_detail' });
          await dispatch(updateInfluencer({ id: influencerId, data: payload })).unwrap();
        } catch (error) {
          setIsActive((prev) => !prev);
          showToast({ type: 'error', message: 'Gagal Mengubah Status Influencer' });
        }
      },
    });
  };

  useEffect(() => {
    if (checkEmptyObject(byId)) return;
    if (checkEmptyObject(categories)) return;

    const categoryNames = byId.referral_setting.categories?.map(
      (id) => categories.category.find((cat) => cat.id === id)?.name,
    );

    const formattedDate = format(new Date(byId.influencer_expired_at), 'dd MMM yyyy');

    setInfluencerData({
      name: byId.name?.toUpperCase(),
      value: byId.referral_setting?.value,
      value_type: byId.referral_setting?.value_type,
      referral: byId.referral,
      referral_link: generateReferralLink(byId.referral),
      services: byId.referral_setting?.services ?? [],
      categories: categoryNames ?? [],
      min_duration: byId.referral_setting?.min_duration,
      active_period: formattedDate,
      percentage_rule: byId.referral_setting?.percentage_rule,
      total_click: byId.total_click,
    });
    setPriceType(arrayRadionButton.find((item) => item.value === byId.referral_setting.value_type).id);
    setIsActive(byId.is_influencer_active);
  }, [byId, categories]);

  const handleCopyReferral = async () => {
    const domain = window.location.origin;
    const excludeStringBackOffice = domain.replace('backoffices.', '');

    const link = `${excludeStringBackOffice}/event/${byId.referral}`;

    try {
      await navigator.clipboard.writeText(link);
      showToast({ type: 'success', message: 'Berhasil Copy Link Referral' });
    } catch (error) {
      showToast({ type: 'error', message: 'Gagal Copy Link Referral' });
    }
  };

  if (isLoading) return <LoadingSpinner />;

  // return (
  //   <div>
  //     {/* <InfluencerMetricsChart /> */}

  //     <div style={{ height: '100vh' }}>
  //       <PDFViewer width="100%" height="100%">
  //         <Invoice />
  //       </PDFViewer>
  //     </div>
  //   </div>
  // );

  return (
    <div className="influencer-detail">
      <button className="back-btn" onClick={() => navigate('/influencer')}>
        <ArrowLeft />
        <span>Kembali</span>
      </button>

      <TableWrapper title="Detail Influencer" icon={<PeopleIcon fill="#FF9900" width="25px" height="25px" />}>
        <div className="influencer-detail__form">
          <InputField
            label="Nama Influencer"
            placeholder="Tulis Nama Influencer"
            value={influencerData.name || ''}
            readOnly
            disable
          />

          <div className="referral-code-field">
            <InputField
              label="Generate Link"
              placeholder="Generate Link"
              value={influencerData.referral_link || ''}
              readOnly
              disable
            />
            <Button className="copy-btn" onClick={handleCopyReferral}>
              <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="30" height="30" rx="3" fill="#FF9900" />
                <path
                  d="M21.4167 5.83325C21.9029 5.83325 22.3692 6.02641 22.713 6.37022C23.0568 6.71404 23.25 7.18036 23.25 7.66659V18.6666C23.25 19.1528 23.0568 19.6191 22.713 19.9629C22.3692 20.3068 21.9029 20.4999 21.4167 20.4999H19.5833V22.3333C19.5833 22.8195 19.3902 23.2858 19.0464 23.6296C18.7025 23.9734 18.2362 24.1666 17.75 24.1666H8.58333C8.0971 24.1666 7.63079 23.9734 7.28697 23.6296C6.94315 23.2858 6.75 22.8195 6.75 22.3333V11.3333C6.75 10.847 6.94315 10.3807 7.28697 10.0369C7.63079 9.69307 8.0971 9.49992 8.58333 9.49992H10.4167V7.66659C10.4167 7.18036 10.6098 6.71404 10.9536 6.37022C11.2975 6.02641 11.7638 5.83325 12.25 5.83325H21.4167ZM13.1667 17.7499H11.3333C11.0997 17.7502 10.875 17.8396 10.7051 18C10.5352 18.1604 10.433 18.3796 10.4193 18.6129C10.4056 18.8461 10.4815 19.0758 10.6314 19.2549C10.7814 19.4341 10.9941 19.5492 11.2261 19.5768L11.3333 19.5833H13.1667C13.4003 19.583 13.625 19.4935 13.7949 19.3331C13.9648 19.1728 14.067 18.9535 14.0807 18.7203C14.0944 18.4871 14.0185 18.2574 13.8686 18.0782C13.7186 17.8991 13.5059 17.7839 13.2739 17.7563L13.1667 17.7499ZM21.4167 7.66659H12.25V9.49992H17.75C18.2362 9.49992 18.7025 9.69307 19.0464 10.0369C19.3902 10.3807 19.5833 10.847 19.5833 11.3333V18.6666H21.4167V7.66659ZM15 14.0833H11.3333C11.0902 14.0833 10.8571 14.1798 10.6852 14.3517C10.5132 14.5236 10.4167 14.7568 10.4167 14.9999C10.4167 15.243 10.5132 15.4762 10.6852 15.6481C10.8571 15.82 11.0902 15.9166 11.3333 15.9166H15C15.2431 15.9166 15.4763 15.82 15.6482 15.6481C15.8201 15.4762 15.9167 15.243 15.9167 14.9999C15.9167 14.7568 15.8201 14.5236 15.6482 14.3517C15.4763 14.1798 15.2431 14.0833 15 14.0833Z"
                  fill="white"
                />
              </svg>
            </Button>
          </div>

          <div className="comission-field">
            <h3>Komisi</h3>
            <div className="radio">
              <RadioButton name="price" data={arrayRadionButton} state={priceType} setState={() => {}} />
            </div>

            {(priceType === 'pr1' || priceType === '') && (
              <InputField placeholder="Rp 0" value={setCurrency(influencerData.value) || 0} disable />
            )}

            {priceType === 'pr2' && (
              <>
                <div className="double-column">
                  <InputField
                    type="text"
                    placeholder="Pilih Kondisi"
                    value={PERCENTAGE_RULE[influencerData.percentage_rule]}
                    min={0}
                    disable
                  />
                  <InputField type="number" placeholder="0%" data value={influencerData.value} min={0} disable />
                </div>
              </>
            )}
          </div>

          <InputField label="Kode Referral" placeholder="Kode Referral" value={influencerData.referral || ''} disable />

          <SelectFieldDropdown
            label="Tipe Sewa"
            htmlFor="tipe-sewa"
            data={tipeSewa}
            placeholder="Tipe Sewa"
            value={influencerData.services}
            checkBox={true}
            disable
          />

          <div className="segmented-input readonly">
            <span className="label">Kategori Mobil</span>
            <div className="segment">
              {influencerData.categories.length ? (
                influencerData.categories.map((category) => (
                  <span key={category} className="option">
                    {category}
                  </span>
                ))
              ) : (
                <span className="option">-</span>
              )}
            </div>
          </div>

          <div className="double-column">
            <InputField
              label="Total Penggunaan"
              placeholder="Rp. 0"
              disable
              value={setCurrency(referralHistory?.total_usage) || 0}
            />
            <InputField label="Total Redeem" placeholder="0" disable value={referralHistory?.total_redeem || 0} />
          </div>

          <InputField label="Minimal Sewa (Hari)" placeholder="0" disable value={influencerData.min_duration || 0} />

          <div className="double-column">
            <InputField label="Total Click" placeholder="0" disable value={influencerData?.total_click || 0} />
            <InputField
              label="Masa Aktif"
              placeholder="Masa Aktif"
              value={influencerData.active_period || ''}
              disable
            />
          </div>

          <div className="status-info">
            <h3>Status Influencer</h3>
            <div className="status-info__toggle-wrapper">
              <div className="user__toggle-status">
                <label className="switch">
                  <input type="checkbox" onChange={toggleStatus} role={'switch'} checked={isActive} />
                  <span className="slider"></span>
                </label>
              </div>
              <div className="user__status-info">
                {isActive ? (
                  <span className="user__status-badge user__status-badge--active">Active</span>
                ) : (
                  <span className="user__status-badge user__status-badge--blocked">Inactive</span>
                )}
              </div>
            </div>
          </div>
        </div>
      </TableWrapper>

      <InfluencerMetricsChart />
      <ReferralHistory />
    </div>
  );
};

export default InfluencerDetailPage;

const tipeSewa = [
  {
    id: 0,
    name: 'Dengan Supir',
    value: 'with_driver',
  },
  {
    id: 1,
    name: 'Tanpa Supir',
    value: 'without_driver',
  },
  {
    id: 2,
    name: 'Airport Transfer',
    value: 'airport_transfer',
  },
];

const PERCENTAGE_RULE = {
  order_total: 'Dari Total Harga Pesanan',

  vehicle_total: 'Dari Total Harga Kendaraan',
};
